export default "__VITE_ASSET__DHQS3$jt__"